export const PARSE_PATH_NAME: Record<string, string> = {
  "treasure game": "treasure game$",
};
export const PARSE_USERNAME: Record<string, string> = {
  TreasureGame$: "Treasure Game$",
};
